<template>
  <div id="commonFilter">
    <div class="bg" @click="clickBackdrop"></div>
    <div class="common-filter-container" :class="{unsetradius: isMobile}">
      <p class="filter__title" v-if="isTitle">{{title}}</p>
      <div class="filter__list">
        <div v-for="(item, index) in items" :key="index"
          class="filter__item"
          :class="{on: item.value === select}"
          @click="clickFilterItem(item.value)">{{item.name}}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CommonFilterContainer',
  props:{
    title: {
      type: String,
      default: 'Filter'
    },
    items: {
      type: Array,
      default: () => []
    },
    selected: {
      type: [String, Number],
      default: '',
    },
    isTitle: {
      type: Boolean,
      default: true
    }
  },
  data(){
    return {
      isMobile: window.innerWidth <= 768,
      select: this.selected,
    }
  },
  mounted(){
    const body = document.querySelector('body');
    body.style.overflow = 'hidden';
  },
  beforeDestroy(){
    const body = document.querySelector('body');
    body.style.removeProperty('overflow');
  },
  methods: {
    clickBackdrop: function() {
      this.$emit('click-backdrop')
    },
    clickFilterItem: function(value){
      this.$emit('select-filter', value);
      this.clickBackdrop();
    },
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/_index.scss';
#commonFilter{
  position: fixed;
  z-index: 999;
  .bg{
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    left: 0;
  }
  .common-filter-container{
    width: 448px;
    padding: 24px;
    border-radius: 12px;
    background-color: #ffffff;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .filter__title{
      padding-top: 12px;
      padding-bottom: 24px;
      font-size: 22px;
      font-weight: $medium;
    }
    .filter__list{
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
      .filter__item{
        width: calc(50% - 4px);
        height: 60px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #e1e1eb;
        border-radius: 8px;
        cursor: pointer;
        &:nth-child(2n){
          margin-left: 8px;
        }
        &:nth-child(n + 3){
          margin-top: 8px;
        }
        &.on{
          border-color: #000000;
        }
      }
    }
  }
  
  .unsetradius{
    border-radius: unset;
  }
}
@media all and (max-width: 768px){
  #commonFilter{
    .common-filter-container{
      width: 100%;
      bottom: 0px;
      top: unset;
      transform: translate(-50%, 0);
      padding-bottom: calc(24px + constant(safe-area-inset-bottom));
      padding-bottom: calc(24px + env(safe-area-inset-bottom));
    }
  }
}
</style>